import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import useDashboard from './useDashboard';
import PieChartComponent from '../../../library/SimpleControls/PieChartControl';

const JobTypeDistribution = () => {
    const { state } = useContext(SmartContext);
    const { getJobTypeDistributionData } = useDashboard();

    useEffect(() => {
        getJobTypeDistributionData();
    }, []);

    if (isEmpty(state.data?.dashboardData?.jobTypeDistribution)) 
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <PieChartComponent data={state?.data?.dashboardData?.jobTypeDistribution} />
        </>
    );
};

export default JobTypeDistribution;
